import _ from 'lodash'
import defaultConfig from './default'
import paymentTypes from 'payment-types'
import orderService from 'service/order'

module.exports = _.merge({}, defaultConfig, {
	name: '农行',
	orderListApi: '/v1/abchina/myOrders',
	loginExtraHintText: '首次查询订单需要手机号验证',
	hideCoupon: false,
	stripBrand: true,
	hideReview: true,
	hideBuyNum: true,
	needNav: true,
  isHideTravel: true,
	match() {
		let userAgent = navigator.userAgent
		return /Bankabc/.test(userAgent)
	},
	pay(subjectId, subjectType, paymentAmount) {
		return orderService.unifiedPay({
			subjectId,
			subjectType,
			paymentAmount,
			paymentType: paymentTypes.nonghang
		}).then((data) => {
			window.location.href = data.paymentParams
		})
	}
})



// WEBPACK FOOTER //
// ./src/mods/channels/nonghang.js